/* eslint-disable no-undef */
export default {
	name: "create-delivery-order-modal",
	props: ["heading", "modalId", "showModal", "customer", "shippingAddress"],
	emits: ["placeOrderOkClicked"],
	data() {
		return {
			company: {},
			customerShippingAddress: {},
			billingAddressValidation:{
				hasError: false,
				errorMessage: null
			},
			orderValidationRulesResults: [],
			expectedDateOfDeliveryStartDate: new Date().setDate(new Date().getDate() + 2),
			initialiseExpectedDate: true,
			order:{
				products:[],
				productsHasError: false,
				productsErrorMessage: null,
				customerPurchaseOrderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				shippingAddressId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				notes: null,
				totalAmount: 0,
				discountedAmount: 0,
				expectedDateOfDelivery: {
					value: null,
					hasError: false,
					errorMessage: null
				},
                expectedDatesOfDelivery: {
                    value: [{
                        value: null,
                        hasError: false,
                        errorMessage: null
                    }],
                    hasError: false,
                    errorMessage: null
                },
                orderFrequency: {
                    value: 1,
                    hasError: false,
                    errorMessage: null
                }
			},
			orderTypeId: orderHelper.orderType.delivery,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			productFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			hasError: false
		};
	},
	methods: {
		onProductSelected(products){
			this.order.products = [];
			this.order.totalAmount = 0;
			this.order.discountedAmount = 0;
			console.log("products", products);
			this.hasError = products.hasError;
			if(!products.hasError){
				for(let i = 0; i < products.selectedProducts.length; i++){
					let obj = JSON.parse( JSON.stringify( products.selectedProducts[i]));
					let itemToOrder = {
						productId: obj.productId,
						quantity: obj.quantity,
						totalPrice: obj.total,
						unitPrice: obj.basePrice,
						// discountedAmount: obj.discountedAmountTotal
						discountedAmount: obj.discountAmount === null ? 0 : obj.discountAmount
					};
					this.order.products.push(itemToOrder);
					this.order.totalAmount += obj.total;
					this.order.discountedAmount += obj.discountedAmountTotal;
				}
			}

			console.log("order create", this.order);
		},
		onShippingAddressSelected(shippingAddressId){
			this.order.shippingAddressId.value = shippingAddressId;
		},
		clearMessageAlerts(){
			this.clearModel();
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			this.orderValidationRulesResults = [];
			this.$emit("placeOrderOkClicked", true);
		},
		onExpectedDateOfDeliverySelect(date, index){
			console.log("Date selected:", date, "for index:", index);
			if (index !== undefined) {
				this.order.expectedDatesOfDelivery.value[index].value = date;
				console.log("Updated expectedDatesOfDelivery:", this.order.expectedDatesOfDelivery.value);
			} else {
				this.order.expectedDateOfDelivery.value = date;
				console.log("Updated expectedDateOfDelivery:", this.order.expectedDateOfDelivery.value);
			}
			this.initialiseExpectedDate = false;
		},
		onOrderFrequencyChange() {
			const frequency = parseInt(this.order.orderFrequency.value) || 1;
			const currentDates = this.order.expectedDatesOfDelivery.value;
			
			// Ensure we have the right number of date fields
			if (frequency > currentDates.length) {
				// Add more date fields
				for (let i = currentDates.length; i < frequency; i++) {
					currentDates.push({
						value: null,
						hasError: false,
						errorMessage: null
					});
				}
			} else if (frequency < currentDates.length) {
				// Remove excess date fields
				currentDates.splice(frequency);
			}
		},
		onModalCloseClick() {
			this.clearModel();
			this.$emit("placeOrderOkClicked", true);
		},
		onModalSaveClick(){
			//save changes
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			if(this.hasError){
				this.loading = false;
				return;
			}
			
			// Collect the expected delivery dates (filter out null/empty values)
			const expectedDeliveryDates = this.order.expectedDatesOfDelivery.value
				.map(dateField => dateField.value)
				.filter(date => date !== null && date !== undefined && date !== '' && date !== 'Invalid Date');
			
			console.log("Expected delivery dates:", expectedDeliveryDates);
			console.log("Order frequency:", this.order.orderFrequency.value);
			console.log("All date fields:", this.order.expectedDatesOfDelivery.value);
				
			let request = {
				customerPurchaseOrderNumber: this.order.customerPurchaseOrderNumber.value,
				itemsToOrder: this.order.products,
				companyAddressId: this.order.shippingAddressId.value === null ? 0 : this.order.shippingAddressId.value,
				notes: this.order.notes,
				totalAmount: this.order.totalAmount,
				discountedAmount: this.order.discountedAmount,
				expectedDeliveryDate: this.order.expectedDateOfDelivery.value, // Keep for backward compatibility
				expectedDeliveryDates: expectedDeliveryDates.length > 0 ? expectedDeliveryDates : null,
				orderFrequency: this.order.orderFrequency.value
			};
			orderService.addOrUpdateDeliveryOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.deliveryOrderValidationResponse.valuesAreValid){
							this.loading = false;
							this.showSuccessMessage = true;
							this.successMessage = "Order saved successfully";
							this.clearModel();
						}
						else{
							this.order.productsHasError = successResponse.data.deliveryOrderValidationResponse.itemsToOrderValidationResponse.hasError;
							this.order.productsErrorMessage = successResponse.data.deliveryOrderValidationResponse.itemsToOrderValidationResponse.message;

							this.order.shippingAddressId.hasError = successResponse.data.deliveryOrderValidationResponse.shippingAddressValidationResponse.hasError;
							this.order.shippingAddressId.errorMessage = successResponse.data.deliveryOrderValidationResponse.shippingAddressValidationResponse.message;

							this.order.customerPurchaseOrderNumber.hasError = successResponse.data.deliveryOrderValidationResponse.customerPurchaseOrderNumberValidationResponse.hasError;
							this.order.customerPurchaseOrderNumber.errorMessage = successResponse.data.deliveryOrderValidationResponse.customerPurchaseOrderNumberValidationResponse.message;

							this.order.expectedDateOfDelivery.hasError = successResponse.data.deliveryOrderValidationResponse.expectedDateOfDeliveryValidationResponse.hasError;
							this.order.expectedDateOfDelivery.errorMessage = successResponse.data.deliveryOrderValidationResponse.expectedDateOfDeliveryValidationResponse.message;
							
							// Handle multiple dates validation
							if (successResponse.data.deliveryOrderValidationResponse.expectedDatesOfDeliveryValidationResponse) {
								this.order.expectedDatesOfDelivery.hasError = successResponse.data.deliveryOrderValidationResponse.expectedDatesOfDeliveryValidationResponse.hasError;
								this.order.expectedDatesOfDelivery.errorMessage = successResponse.data.deliveryOrderValidationResponse.expectedDatesOfDeliveryValidationResponse.message;
								
								// Set individual date field errors if available
								if (successResponse.data.deliveryOrderValidationResponse.expectedDatesOfDeliveryValidationResponse.individualDateErrors) {
									const dateErrors = successResponse.data.deliveryOrderValidationResponse.expectedDatesOfDeliveryValidationResponse.individualDateErrors;
									this.order.expectedDatesOfDelivery.value.forEach((dateField, index) => {
										if (dateErrors[index]) {
											dateField.hasError = dateErrors[index].hasError;
											dateField.errorMessage = dateErrors[index].message;
										}
									});
								}
							}

							// if(successResponse.data.deliveryOrderValidationResponse.billingAddressValidationResponse !== null){
							// 	this.billingAddressValidation.hasError = successResponse.data.deliveryOrderValidationResponse.billingAddressValidationResponse.hasError;
							// 	this.billingAddressValidation.errorMessage = successResponse.data.deliveryOrderValidationResponse.billingAddressValidationResponse.message;
							//
							// 	this.showErrorMessage = this.billingAddressValidation.hasError;
							// 	this.errorMessage = this.billingAddressValidation.errorMessage;
							// }
							this.orderValidationRulesResults = successResponse.data.orderValidationResults;
							var modalContent = document.getElementById(this.modalId)
							if (modalContent) {
								modalContent.scrollTop = 0;
							}
						}
					}
					else{
						// failed clear and close modal
						this.clearMessageAlerts();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearModel(){
			this.orderValidationRulesResults = [];
			this.order = {
				products:[],
				productsHasError: false,
				productsErrorMessage: null,
				customerPurchaseOrderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				shippingAddressId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				notes: null,
				expectedDateOfDelivery: {
					value: null,
					hasError: false,
					errorMessage: null
				},
                expectedDatesOfDelivery: {
                    value: [{
                        value: null,
                        hasError: false,
                        errorMessage: null
                    }],
                    hasError: false,
                    errorMessage: null
                },
                orderFrequency: {
                    value: 1,
                    hasError: false,
                    errorMessage: null
                }
			};
		}
	},
	mounted: function () {
		this.orderTypeId = orderHelper.orderType.delivery;
		// Initialize order frequency and ensure at least one delivery date field
		if (!this.order.orderFrequency.value || this.order.orderFrequency.value < 1) {
			this.order.orderFrequency.value = 1;
		}
		this.onOrderFrequencyChange();
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					//$("#" + this.modalId).modal("show");
					$("#" + this.modalId).modal({
						keyboard: false,
						backdrop: 'static',
						show: true
					});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		shippingAddress: {
			handler: function (){
				console.log("shippingAddress", this.shippingAddress);
				if(this.shippingAddress !== null && this.shippingAddress !== undefined){
					this.order.shippingAddressId.value = this.shippingAddress.companyAddressId;
					this.customerShippingAddress = this.shippingAddress;
				}
			}
		},
		customer:{
			handler: function (){
				console.log("customer", this.customer);
				if(this.customer !== null){
					this.company = this.customer;
				}
			}
		}
	}
};
